import BuildingDetail from "src/pages/building/details/BuildingDetail";
import BuildingList from "src/pages/building/list/BuildingList";
import InitCtrlRoom from "src/pages/init/InitCtrlRoom";
import Login from "src/pages/login/Login";
import RootPage from "src/pages/root/RootPage";
import WorkOrderDetailAuthenticated from "src/pages/workOrder/workOrderAuthenticated/detail/WorkOrderDetailAuthenticated";
import WorkOrderListAuthenticated from "src/pages/workOrder/workOrderAuthenticated/list/WorkOrderListAuthenticated";

import WorkOrderDetail from "src/pages/workOrder/WorkOrderDetail";
import WorkOrderList from "src/pages/workOrder/WorkOrderList";

import ContractDetailMain from "src/pages/contract/detail/ContractDetailMain";
import ContractFormMain from "src/pages/contract/form/ContractFormMain";
import ContractList from "src/pages/contract/list/ContractList";

import BillingScheduleDetail from "src/pages/billing/detail/BillingScheduleDetail";
import BillingScheduleForm from "src/pages/billing/form/BillingScheduleDetail";
import BillingList from "src/pages/billing/list/BillingScheduleList";

import CommonSpaceSettlementList from "src/pages/commonSpaceSettlement/list/CommonSpaceSettlementList";
import ReservationDetail from "src/pages/reservation/detail/ReservationDetail";
import ReservationList from "src/pages/reservation/list/ReservationList";

import OrganizaionDetail from "src/pages/organization/detail/OrganizationDetail";
import OrganizaionForm from "src/pages/organization/form/OrganizationForm";
import OrganizaionList from "src/pages/organization/list/OrganizationList";

import ChargeItemsDetail from "src/pages/chargeItems/detail/ChargeItems";
import ChargeMntDetail from "src/pages/chargeMnt/detail/ChargeMntDetail";
import ChargeMntForm from "src/pages/chargeMnt/form/ChargeMntForm";
import ChargeMntList from "src/pages/chargeMnt/list/ChargeMntList";

import AccessDenied from "src/pages/accessDenied/AccessDenied";
import Dashboard from "src/pages/dashboard";
import WorkOrderFormAuthenticated from "src/pages/workOrder/workOrderAuthenticated/form/WorkOrderFormAuthenticated";
import { Route } from "src/types/common";
import PagePath from "../pagePath.json";

import { PartnerFeature } from "src/api/public-types";
import BuildingForm from "src/pages/building/forms/BuildingForm";
import NoticeDetail from "src/pages/notice/detail/NoticeDetail";
import NoticeForm from "src/pages/notice/form/NoticeForm";
import NoticeList from "src/pages/notice/list/NoticeList";
import PriceDetail from "src/pages/price/detail/PriceDetail";
import PriceForm from "src/pages/price/form/PriceForm";
import PriceList from "src/pages/price/list/PriceList";
import { ProductDetail, ProductForm, ProductList } from "src/pages/product";
import ProviderDetail from "src/pages/provider/detail/ProviderDetail";
import ProviderForm from "src/pages/provider/forms/ProviderForm";
import ProviderList from "src/pages/provider/list/ProviderList";
import QuestionDetail from "src/pages/question/detail/QuestionDetail";
import QuestionForm from "src/pages/question/form/QuestionForm";
import QuestionList from "src/pages/question/list/QuestionList";
import { UserDetail, UserForm, UserList } from "src/pages/user";
import { VisitorDetail, VisitorList } from "src/pages/visitor";
import VisitorAdd from "src/pages/visitor/add/VisitorAdd";

import VocDetail from "src/pages/voc/detail/VocDetail";
import VocForm from "src/pages/voc/form/VocForm";
import VocList from "src/pages/voc/list/VocList";

import GuideDetail from "src/pages/guide/detail/GuideDetail";
import GuideForm from "src/pages/guide/form/GuideForm";
import GuideList from "src/pages/guide/list/GuideList";
import ReservationForm from "src/pages/reservation/form/ReservationForm";

import AccessDeviceList from "src/pages/accessDevices/AccessDeviceList";
import AccessDeviceDetail from "src/pages/accessDevices/detail/AccessDeviceDetail";
import AccessGroupDetail from "src/pages/accessGroup/detail/AccessGroupDetail";
import AccessGroupForm from "src/pages/accessGroup/form/AccessGroupForm";
import AccessGroupList from "src/pages/accessGroup/list/AccessGroupList";
import AccessRecordList from "src/pages/accessRecord/list/AccessRecordList";
import CctvDeviceDetail from "src/pages/cctv/detail/CctvDeviceDetail";
import CctvDeviceList from "src/pages/cctv/list/CctvDeviceList";
import ContractGroupCustomField from "src/pages/contractGroup/customField/ContractGroupCustomField";
import ContractGroupDetail from "src/pages/contractGroup/detail/ContractGroupDetail";
import ContractGroupForm from "src/pages/contractGroup/form/ContractGroupForm";
import ContractGroupList from "src/pages/contractGroup/list/ContractGroupList";
import CustomLinkDetail from "src/pages/customLink/detail/CustomLinkDetail";
import CustomLinkForm from "src/pages/customLink/form/CustomLinkForm";
import CustomLinkList from "src/pages/customLink/list/CustomLinkList";
import IotConfigList from "src/pages/iotConfig/IotConfigList";
import IotConfigDetail from "src/pages/iotConfig/detail/IotConfigDetail";
import IotTabManager from "src/pages/iotConfig/display/IotTabManager";
import SpaceMonitoring from "src/pages/monitoring/SpaceMonitoring";
import ReservationCalendar from "src/pages/reservation/calendar/ReservationCalendar";
import ReservationConfigForm from "src/pages/reservationSetting/ReservationConfigForm";
import SettingForm from "src/pages/setting/SettingForm";
import SmartThingsPro from "src/pages/smartThingsPro/SmartThingsPro";
import UserAdditionalInfoCustomField from "src/pages/userAdditionalInfo/customField/UserAdditionalInfoCustomField";
import UserAdditionalInfoDetail from "src/pages/userAdditionalInfo/detail/UserAdditionalInfoDetail";
import UserAdditionalInfoList from "src/pages/userAdditionalInfo/list/UserAdditionalInfoList";
import VisitorAccessInfo from "src/pages/visitor/detail/VisitorAccessInfo";

export const routeList: Route[] = [
  { path: `/`, component: RootPage },

  // 관리자 권한 없는 페이지
  { path: PagePath.accessDenied, component: AccessDenied, isProtectRoute: true },

  // 대시보드
  {
    path: PagePath.main,
    component: Dashboard,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  // 공간 모니터링
  {
    path: PagePath.monitoring,
    component: SpaceMonitoring,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  // 워크오더 무인증
  { path: PagePath.workOrder.nonAuthenticated.detail, component: WorkOrderDetail },
  { path: PagePath.workOrder.nonAuthenticated.list, component: WorkOrderList },

  //워크오더 인증
  {
    path: PagePath.workOrder.authenticated.list,
    component: WorkOrderListAuthenticated,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.WORKORDER,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.workOrder.authenticated.detail,
    component: WorkOrderDetailAuthenticated,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.WORKORDER,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.workOrder.authenticated.form,
    component: WorkOrderFormAuthenticated,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.WORKORDER,
    // permission: PartnerPermission.WRITE,
  },

  // 로그인
  { path: PagePath.login, component: Login },
  { path: PagePath.partnerLogin, component: Login },
  { path: PagePath.init, component: InitCtrlRoom, isProtectRoute: true },
  // { path: PagePath.main, component: Main, isProtectRoute: true, withPartner: true },

  // 건물
  {
    path: PagePath.building.list,
    component: BuildingList,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.building.detail,
    component: BuildingDetail,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.building.form,
    component: BuildingForm,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.WRITE,
  },

  //신청/계약
  {
    path: PagePath.contract.list,
    component: ContractList,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.contract.detail,
    component: ContractDetailMain,
    withPartner: true,
    isProtectRoute: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.contract.form,
    component: ContractFormMain,
    withPartner: true,
    isProtectRoute: true,
    // permission: PartnerPermission.WRITE,
  },
  // 신청/계약 S2 전용 페이지
  {
    path: PagePath.contractS2.list,
    component: ContractList,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.contractS2.detail,
    component: ContractDetailMain,
    withPartner: true,
    isProtectRoute: true,
  },
  {
    path: PagePath.contractS2.form,
    component: ContractFormMain,
    withPartner: true,
    isProtectRoute: true,
  },
  {
    path: PagePath.smartThingsPro,
    component: SmartThingsPro,
    withPartner: true,
    isProtectRoute: true,
  },
  //빌링스케줄
  {
    path: PagePath.billing.list,
    component: BillingList,
    isProtectRoute: true,
    withPartner: true, //
  },
  {
    path: PagePath.billing.detail,
    component: BillingScheduleDetail,
    withPartner: true,
    isProtectRoute: true,
  },
  {
    path: PagePath.billing.form,
    component: BillingScheduleForm,
    withPartner: true,
    isProtectRoute: true, //
  },
  {
    path: PagePath.billingS2.list,
    component: BillingList,
    isProtectRoute: true,
    withPartner: true, //
  },
  {
    path: PagePath.billingS2.detail,
    component: BillingScheduleDetail,
    withPartner: true,
    isProtectRoute: true,
  },
  {
    path: PagePath.billingS2.form,
    component: BillingScheduleForm,
    withPartner: true,
    isProtectRoute: true, //
  },

  // 공용공간 예약
  {
    path: PagePath.reservation.list, //
    component: ReservationList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.reservation.detail, //
    component: ReservationDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.reservation.form, //
    component: ReservationForm,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.READ,
  },
  // 공용공간 정산 (계약 그룹 API 기반 → CONTRACT 권한)
  {
    path: PagePath.commonSpaceSettlement.list, //
    component: CommonSpaceSettlementList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.reservation.calendar, //
    component: ReservationCalendar,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    isCleaningLayout: true,
  },

  // 공용공간 요금
  {
    path: PagePath.price.list, //
    component: PriceList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.price.form, //
    component: PriceForm,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.price.detail, //
    component: PriceDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.RESERVATION,
    // permission: PartnerPermission.READ,
  },

  // 사업자
  {
    path: PagePath.organization.list,
    component: OrganizaionList,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.organization.form,
    component: OrganizaionForm,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.organization.detail,
    component: OrganizaionDetail,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  // 이용자
  {
    path: PagePath.user.list,
    component: UserList,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.user.form,
    component: UserForm,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.user.detail,
    component: UserDetail,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  // 방문자
  {
    path: PagePath.visitor.list,
    component: VisitorList,
    isProtectRoute: true,
    withPartner: true,
    //privilege: PartnerPrivilegeCode.VISITOR
  },
  // 방문자
  {
    path: PagePath.visitor.mobileList,
    component: VisitorList,
    isProtectRoute: true,
    withPartner: true,
    //privilege: PartnerPrivilegeCode.VISITOR
  },
  {
    path: PagePath.visitor.add,
    component: VisitorAdd,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.WRITE,
  },

  {
    path: PagePath.visitor.detail,
    component: VisitorDetail,
    isProtectRoute: true,
    withPartner: true,
    //  privilege: PartnerPrivilegeCode.VISITOR
  },
  {
    path: PagePath.visitor.mobileDetail,
    component: VisitorDetail,
    isProtectRoute: true,
    withPartner: true,
    //  privilege: PartnerPrivilegeCode.VISITOR
  },
  {
    path: PagePath.visitor.accessInfo,
    component: VisitorAccessInfo,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  // 공간상품
  {
    path: PagePath.product.list,
    component: ProductList,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.product.detail,
    component: ProductDetail,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.product.form,
    component: ProductForm,
    isProtectRoute: true,
    withPartner: true, //
    // permission: PartnerPermission.WRITE,
  },

  // 정산정보
  {
    path: PagePath.provider.list,
    component: ProviderList,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.provider.form,
    component: ProviderForm,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.provider.detail,
    component: ProviderDetail,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },

  //v.1.19 작업 > Harry 수정
  // 관리비 부과항목관리
  // {
  //   path: PagePath.chargeItems.form,
  //   component: ChargeItemsForm,
  //   isProtectRoute: true,
  //   withPartner: true,
  //   allowEnvironments: ["dev", "stg"],
  //   feature: PartnerFeature.MANAGEMENT_FEE,
  //   // permission: PartnerPermission.WRITE,
  // },
  // {
  //   path: PagePath.chargeItems.list,
  //   component: ChargeItemsList,
  //   isProtectRoute: true,
  //   withPartner: true,
  //   allowEnvironments: ["dev", "stg"],
  //   feature: PartnerFeature.MANAGEMENT_FEE,
  //   // permission: PartnerPermission.READ,
  // },
  {
    path: PagePath.chargeItems.detail,
    component: ChargeItemsDetail,
    isProtectRoute: true,
    withPartner: true,
    allowEnvironments: ["dev", "stg"],
    feature: PartnerFeature.MANAGEMENT_FEE,
    // permission: PartnerPermission.READ,
  },

  // 관리비 부과항목관리
  {
    path: PagePath.chargeMnt.list,
    component: ChargeMntList,
    isProtectRoute: true,
    withPartner: true,
    allowEnvironments: ["dev", "stg"],
    feature: PartnerFeature.MANAGEMENT_FEE,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.chargeMnt.form,
    component: ChargeMntForm,
    isProtectRoute: true,
    withPartner: true,
    allowEnvironments: ["dev", "stg"],
    feature: PartnerFeature.MANAGEMENT_FEE,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.chargeMnt.detail,
    component: ChargeMntDetail,
    isProtectRoute: true,
    withPartner: true,
    allowEnvironments: ["dev", "stg"],
    feature: PartnerFeature.MANAGEMENT_FEE,
    // permission: PartnerPermission.READ,
  },

  // 공지사항
  {
    path: PagePath.notice.list,
    component: NoticeList,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.notice.detail,
    component: NoticeDetail,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.notice.form,
    component: NoticeForm,
    isProtectRoute: true,
    withPartner: true,
    // permission: PartnerPermission.WRITE,
  },

  // 상담관리
  {
    path: PagePath.question.list,
    component: QuestionList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.question.detail,
    component: QuestionDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.question.form,
    component: QuestionForm,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.WRITE,
  },

  // voc
  {
    path: PagePath.voc.list,
    component: VocList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.voc.detail,
    component: VocDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.READ,
  },
  {
    path: PagePath.voc.form,
    component: VocForm,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CS,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.guide.list,
    component: GuideList,
    isProtectRoute: true,
    withPartner: true,
    // feature: PartnerFeature.CS,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.guide.form,
    component: GuideForm,
    isProtectRoute: true,
    withPartner: true,
    // feature: PartnerFeature.CS,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.guide.detail,
    component: GuideDetail,
    isProtectRoute: true,
    withPartner: true,
    // feature: PartnerFeature.CS,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.customLink.list,
    component: CustomLinkList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CUSTOM_LINK,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.customLink.form,
    component: CustomLinkForm,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CUSTOM_LINK,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.customLink.detail,
    component: CustomLinkDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.CUSTOM_LINK,
    // permission: PartnerPermission.WRITE,
  },
  {
    path: PagePath.cctv.list,
    component: CctvDeviceList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.cctv.detail,
    component: CctvDeviceDetail,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessDevice.list,
    component: AccessDeviceList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessDevice.detail,
    component: AccessDeviceDetail,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessGroup.list,
    component: AccessGroupList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessGroup.detail,
    component: AccessGroupDetail,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessGroup.form,
    component: AccessGroupForm,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.reservationConfig.form,
    component: ReservationConfigForm,
    isProtectRoute: true,
    withPartner: true,
  },

  {
    path: PagePath.iotConfig.list,
    component: IotConfigList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.iotConfig.detail,
    component: IotConfigDetail,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.iotConfig.setting,
    component: IotTabManager,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.accessRecord.list,
    component: AccessRecordList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.contractGroup.list,
    component: ContractGroupList,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.contractGroup.customField,
    component: ContractGroupCustomField,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.contractGroup.form,
    component: ContractGroupForm,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.contractGroup.detail,
    component: ContractGroupDetail,
    isProtectRoute: true,
    withPartner: true,
  },
  {
    path: PagePath.userAdditionalInfo.list,
    component: UserAdditionalInfoList,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.MEMBER_PARTNER_CUSTOM_INFO,
  },
  {
    path: PagePath.userAdditionalInfo.customField,
    component: UserAdditionalInfoCustomField,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.MEMBER_PARTNER_CUSTOM_INFO,
  },
  {
    path: PagePath.userAdditionalInfo.detail,
    component: UserAdditionalInfoDetail,
    isProtectRoute: true,
    withPartner: true,
    feature: PartnerFeature.MEMBER_PARTNER_CUSTOM_INFO,
  },
  {
    path: PagePath.setting.form,
    component: SettingForm,
    isProtectRoute: true,
    withPartner: true,
  },
];
